import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export const translationHttpLoaderFactory: (
  httpClient: HttpClient
) => TranslateHttpLoader = (httpClient: HttpClient) => {
  const meta = inject(Meta);
  const versionMetaTag = meta.getTag('name=version');
  const version = versionMetaTag
    ? versionMetaTag.content
    : new Date().getTime();

  return new TranslateHttpLoader(
    httpClient,
    '/assets/i18n/',
    '.json?v=' + version // Cache-busting
  );
};
